const mainHeaderData = {
    homeTitle: 'Skill up your teams on Secure DevOps',
    homeSubTitle: 'Enable your organisation to increase both security compliance and productivity of software development',
};

export default mainHeaderData;
